import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'users'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getUser (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  getUserSessionData (id) {
    return Client.get(`${resource}/${id}/user_session_data`)
      .then(response => response.data)
  },
  createUserPermissions (payload, id) {
    return Client.post(`${resource}/${id}/user_permissions`, payload)
      .then(response => response.data)
  },
  updateUserPermissions (payload, id) {
    return Client.put(`${resource}/${id}/user_permissions/${id}`, payload)
      .then(response => response.data)
  },
  createUserNotifications (payload, id) {
    return Client.post(`${resource}/${id}/user_notifications`, payload)
      .then(response => response.data)
  },
  updateUserNotifications (payload, id) {
    return Client.put(`${resource}/${id}/user_notifications/${id}`, payload)
      .then(response => response.data)
  },
  getUserAccounts (id) {
    return Client.get(`user_accounts/?userId=${id}`)
      .then(response => response.data)
  },
  createUserAccount (id, accountId) {
    return Client.post('user_accounts', { userId: id, accountId })
      .then(response => response.data)
  },
  deleteUserAccount (uaId) {
    return Client.delete(`user_accounts/${uaId}`)
      .then(response => response.data)
  },
  sendMfaCode (userId, token, method) {
    return Client.post(`${resource}/mfa/send_code`, { user_id: userId, token: token, method: method })
      .then(response => response.data) 
  },
  validateMfaCode (userId, token, code) {
    return Client.post(`${resource}/mfa/validate_code`, { user_id: userId, token: token, code: code })
      .then(response => response.data)
  }
}
